export class IntegrationConnectionDTO {
  integrationConnectionId: number;

  integrationConnectionTypeId: number;

  authData: string;

  config: string;

  isAuthorized: boolean | undefined;

  lastVerified?: string;

  lastError?: string;

  created: string;

  modified?: string;

  integrationTypeIds: number[];

  constructor() {
    this.integrationConnectionId = 0;
    this.integrationConnectionTypeId = 0;
    this.authData = '';
    this.config = '';
    this.isAuthorized = undefined;
    this.created = '';
    this.integrationTypeIds = [];
  }
}
